import React from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { PageHeader } from './PageHeader';

/**
 * A unified layout for pages featuring a searchable or filterable table.
 * Provides a sticky header, a growing table body, and consistent spacing.
 */
export function TablePageLayout({ 
  title, 
  description, 
  action, 
  isLoading, 
  isError, 
  error, 
  children,
  containerRef,
  onScroll,
  maxWidth = '100%'
}) {
  return (
    <div className="d-flex flex-column" style={{ height: 'calc(100vh - 57px)' }}>
      <div>
        <PageHeader
          title={title}
          description={description}
          action={action}
        />
      </div>

      <div className="flex-grow-1 overflow-hidden d-flex flex-column" style={{ minHeight: 0 }}>
        {isError && (
          <div className="px-3">
            <Alert variant="danger">
              {error?.message || 'An error occurred'}
            </Alert>
          </div>
        )}

        <div className={`flex-grow-1 d-flex flex-column overflow-hidden m-3 mt-0 shadow-sm border rounded bg-white`} style={{ maxWidth }}>
          <div className="table-responsive-full" ref={containerRef} onScroll={onScroll}>
            {isLoading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2">Loading data...</div>
              </div>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
